import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';

export type DueDate = {
  dues: number;
  date: string;
  subscriptionId?: number;
  id?: number;
};

@Component({
  selector: 'app-due-dates',
  templateUrl: './due-dates.component.html',
  styleUrls: ['./due-dates.component.scss'],
})
export class DueDatesComponent implements OnInit {
  @Output() changedDuesQuantity$ = new EventEmitter<number>();

  public testQuestions: DueDate[] = [];
  private _initialValue: DueDate = {
    dues: 0,
    date: '',
    subscriptionId: undefined,
    id: undefined,
  };

  constructor(private uiSv: UiServices, private httpSv: HttpService) {}

  ngOnInit() {}

  public async addQuestions(ev: Event) {
    const event = ev.target as HTMLIonInputElement;
    if (event.value && +event.value != this.testQuestions.length) {
      if (this.testQuestions.length) {
        const { role } = await this.uiSv.presentAlert(
          '¿Deseas modificar la cantidad de cuotas?'
        );
        if (role === 'accept') {
          if (+event.value < this.testQuestions.length) {
            const { role: role2 } = await this.uiSv.presentAlert(
              `El numero de cuotas ingresado es menor a la cantidad de respuestas ya establecidas. <br><br> Se borrarán las cuotas desde <b> ${
                +event.value + 1
              }</b> hasta la <b> ${this.testQuestions.length}</b>`
            );

            if (role2 === 'accept') {
              const deletedItems = this.testQuestions.splice(+event.value);
              await this.uiSv.showLoading();
              for (const item of deletedItems) {
                if (item.id) {
                  await this.deleteQuestions(item.id);
                }
              }
              await this.uiSv.loading.dismiss();
              console.log('deletedItems :>> ', deletedItems);
              return;
            }
          }
        }
      }

      const data = [];
      for (
        let index = 0;
        index < +event.value - this.testQuestions.length;
        index++
      ) {
        data.push(this.parseData());
      }
      this.testQuestions.push(...data);
      this.changedDuesQuantity$.emit(this.testQuestions.length);
    }
  }

  private parseData(): DueDate {
    const initialValue: DueDate = JSON.parse(
      JSON.stringify(this._initialValue)
    );
    return initialValue;
  }

  public async deleteQuestions(id: number, fromIndex?: number) {
    if (fromIndex != undefined) {
      const { role } = await this.uiSv.presentAlert(
        '¿Está seguro que desea eliminar esta cuota?'
      );
      if (role !== 'accept') {
        return;
      }
    }
    if (id) {
      await this.httpSv.itemAction({ id }, 'subscription', 'destroyDues');
    }
    if (fromIndex != undefined) {
      this.testQuestions.splice(fromIndex, 1);
    }
  }
}
